// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Config$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/configs/Config.mjs";

function getCMSUrl(locale) {
  return Config$PorterinUtils.cms_url + ("/api/website-order-history?populate=deep&locale=" + locale + "");
}

export {
  getCMSUrl ,
}
/* Config-PorterinUtils Not a pure module */
